import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { SeoService } from '../../core/services/seo.service';
import { WhatsappService } from '../../core/services/whatsapp.service';

interface Plan {
  nombre: string;
  precio: string;
  moneda: string;
  descripcion: string;
  destacado: boolean;
  features: string[];
  cta: string;
}

interface FaqItem {
  pregunta: string;
  respuesta: string;
  open: boolean;
}

@Component({
  selector: 'app-empresas',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './empresas.component.html',
})
export class EmpresasComponent implements OnInit {
  private seo = inject(SeoService);
  private whatsapp = inject(WhatsappService);

  demoLink = this.whatsapp.demoLink();

  planes: Plan[] = [
    {
      nombre: 'Startup',
      precio: '2,699',
      moneda: 'MXN/mes',
      descripcion: 'Para equipos que empiezan a contratar con IA.',
      destacado: false,
      features: [
        'Hasta 5 vacantes activas',
        'Matching con IA básico',
        'Panel de postulaciones',
        'Soporte por WhatsApp',
      ],
      cta: 'Elegir Startup',
    },
    {
      nombre: 'Growth',
      precio: '7,199',
      moneda: 'MXN/mes',
      descripcion: 'Para empresas en expansión que contratan cada mes.',
      destacado: true,
      features: [
        'Vacantes activas ilimitadas',
        'Matching avanzado con IA',
        'Agenda de entrevistas automatizada',
        'Inteligencia de mercado salarial',
        'Soporte prioritario',
      ],
      cta: 'Elegir Growth',
    },
    {
      nombre: 'Enterprise',
      precio: '17,999+',
      moneda: 'MXN/mes',
      descripcion: 'Para organizaciones con volumen alto de contratación.',
      destacado: false,
      features: [
        'Todo lo de Growth',
        'Multi-sede y multi-usuario',
        'Integraciones a medida (ATS/HRIS)',
        'Gerente de cuenta dedicado',
      ],
      cta: 'Hablar con ventas',
    },
  ];

  features = [
    {
      icono: 'auto_awesome',
      titulo: 'Matching automatizado por IA',
      descripcion: 'Nuestra IA filtra y prioriza candidatos según el perfil real de tu vacante, ahorrándote horas de revisión manual.',
    },
    {
      icono: 'event_available',
      titulo: 'Agenda de entrevistas automatizada',
      descripcion: 'Los candidatos agendan directo desde WhatsApp, sincronizado con tu calendario.',
    },
    {
      icono: 'insights',
      titulo: 'Inteligencia de mercado',
      descripcion: 'Compara tus rangos salariales y tiempos de contratación contra el mercado en tiempo real.',
    },
    {
      icono: 'payments',
      titulo: 'Solo pagas si contratas',
      descripcion: 'Nuestro modelo de éxito cobra un 10% de fee solo cuando concretas la contratación.',
    },
  ];

  faqs: FaqItem[] = [
    {
      pregunta: '¿Cómo funciona el fee de éxito del 10%?',
      respuesta:
        'Además de tu plan mensual, cobramos un 10% del salario mensual del candidato solo cuando la contratación se concreta. Si no contratas, no pagas fee.',
      open: false,
    },
    {
      pregunta: '¿Puedo cambiar de plan en cualquier momento?',
      respuesta: 'Sí, puedes subir o bajar de plan cuando lo necesites desde tu panel de empresa.',
      open: false,
    },
    {
      pregunta: '¿En qué países opera Chambia para empresas?',
      respuesta:
        'Operamos en México, Colombia, Ecuador, Costa Rica, Perú, Argentina, Chile, Panamá, Uruguay, República Dominicana y Guatemala.',
      open: false,
    },
    {
      pregunta: '¿Qué necesito para publicar mi primera vacante?',
      respuesta:
        'Solo necesitas verificar tu empresa y describir el puesto. Nuestro equipo te ayuda a optimizar la descripción para atraer mejores candidatos.',
      open: false,
    },
  ];

  ngOnInit(): void {
    this.seo.setMetaTags({
      title: 'Chambia para Empresas — Contrata más rápido con IA',
      description:
        'Recluta talento en LATAM por WhatsApp con matching por IA. Planes desde $2,699 MXN/mes. Solo pagas 10% de fee si contratas.',
      path: '/empresas',
    });
  }

  toggleFaq(item: FaqItem): void {
    item.open = !item.open;
  }
}
